export default function Login() {
  return (
    <div>
      <h1 className="text-3xl font-bold font-montserrat underline text-primary">
        Hello world!
      </h1>
    </div>
  );
}
